import React, { useState } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { useTranslation } from 'react-i18next'

import { PGET } from 'helpers/api'
import useSavedSearch from 'helpers/useSavedSearch'

function Search({ url, search, getData }) {
	const { t } = useTranslation()

	const [value, setValue] = useState('')

	// Sozlamada yoqilgan bo'lsa, yozilgan matn saqlanadi va sahifaga qaytilganda tiklanadi.
	const saveSearch = useSavedSearch((savedValue) => {
		setValue(savedValue)
		requestToServer(savedValue)
	})

	async function requestToServer(value) {
		var data;
		var symbol = '?'
		url.includes("?") ? symbol = '&' : symbol = '?'

		if (value.length === 0) {
			saveSearch(value)
			getData()
		}

		if (value.length > 1) {
			saveSearch(value)
			data = await PGET(url + symbol + "search=" + value)
			search(data.data, value, data.headers['x-total-count'])
		}
	};

	return (
		<div className="position-relative me-2">
			<i className="uil-search input-search-icon"></i>
			<DebounceInput
				type="text"
				className="form-control"
				placeholder={t('SEARCH') + '...'}
				minLength={3}
				debounceTimeout={1000}
				value={value}
				onChange={(e) => {
					setValue(e.target.value)
					requestToServer(e.target.value)
				}}
				onKeyUp={(e) => {
					if (e.keyCode === 13) {
						requestToServer(e.target.value)
					}
				}}
			/>
		</div>
	)
}

export default Search
